import { render } from "./AdminSysFlagsTab.vue?vue&type=template&id=98fe31e8&ts=true"
import script from "./AdminSysFlagsTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysFlagsTab.vue?vue&type=script&lang=ts"

import "./AdminSysFlagsTab.vue?vue&type=style&index=0&id=98fe31e8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__